import { styled } from "@mui/system"
import TextField from "@mui/material/TextField"
import { Box } from "@mui/material"

export const StyledTextField = styled(TextField)(() => ({
  display: "flex",
  height: "32px",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  flex: "1",
  paddingTop: "0px",
}))

export const RequesterLookupWrapper = styled(Box)({
  display: "flex",
  flexDirection: "row",
})

export const AutocompleteWrapper = styled(Box)({
  display: "flex",
  flexDirection: "row",
  flexGrow: 1,
})
